module.exports = __webpack_public_path__ + "img/img28.bd9e2d46.svg";